/* Pellur custom fix — bundle variant selector active-state highlight.

   Root cause: the selected/unselected button colour on <dm-variant-selects>
   is driven by the [data-variant_button-variant='primary'|'outline'] CSS rule
   in dropmagic.css. That attribute selector (2 attributes) outranks the
   .bg-primary-500 utility class that dm-variant-selects.js swaps on click,
   and the JS never updates the data-variant_button-variant ATTRIBUTE — so the
   highlight stays frozen on whatever was server-rendered (e.g. "1 Roller"),
   even though the correct variant is added to cart.

   Fix: keep data-variant_button-variant in sync with the checked radio.
   Kept OUT of the dm-* files on purpose — Dropmagic regenerates those and
   would wipe an inline edit. Loaded from layout/theme.liquid, same as
   dm-cart-bridge.js. */
(function () {
  var SELECTED = null;   // attribute value used for the highlighted button (e.g. "primary")
  var UNSELECTED = null; // attribute value used for the plain button        (e.g. "outline")

  function radioFor(label) {
    var id = label.getAttribute('for');
    return id ? document.getElementById(id) : null;
  }

  // Learn the theme's selected/unselected variant style names from the
  // initial server render (the checked label vs an unchecked one). These are
  // theme settings, identical for every picker, so learning them once is safe.
  function learnVariants() {
    var labels = document.querySelectorAll('dm-variant-selects label[data-variant_button-variant]');
    for (var i = 0; i < labels.length; i++) {
      var radio = radioFor(labels[i]);
      if (!radio) continue;
      var value = labels[i].getAttribute('data-variant_button-variant');
      if (radio.checked && SELECTED === null) SELECTED = value;
      if (!radio.checked && UNSELECTED === null) UNSELECTED = value;
    }
  }

  function syncFieldset(fieldset) {
    if (SELECTED === null || UNSELECTED === null) return;
    var labels = fieldset.querySelectorAll('label[data-variant_button-variant]');
    for (var i = 0; i < labels.length; i++) {
      var radio = radioFor(labels[i]);
      if (!radio) continue;
      labels[i].setAttribute('data-variant_button-variant', radio.checked ? SELECTED : UNSELECTED);
    }
  }

  function syncAll() {
    var fieldsets = document.querySelectorAll('dm-variant-selects fieldset');
    for (var i = 0; i < fieldsets.length; i++) syncFieldset(fieldsets[i]);
  }

  function init() {
    learnVariants();
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Delegated so it keeps working after Dropmagic re-renders the picker.
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('dm-variant-selects input[type="radio"]')) return;
    if (SELECTED === null || UNSELECTED === null) learnVariants();
    var fieldset = target.closest('fieldset');
    if (fieldset) syncFieldset(fieldset);
  });
})();
